import React, { lazy } from 'react';
import i18next from 'i18next';
import { Switch } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { ROUTES } from '~constants/routes';
import { history } from '~redux/store';

import Suspense from '../Suspense';

import AuthenticatedRoute from './components/AuthenticatedRoute';
import styles from './styles.module.scss';

const Home = lazy(() => import('~screens/Home'));
const Login = lazy(() => import('~screens/Login'));

function Routes() {
  return (
    <ConnectedRouter history={history}>
      <div className={`column full-width full-height ${styles.container}`}>
        <Suspense>
          <Switch>
            <AuthenticatedRoute
              {...ROUTES.HOME}
              title={i18next.t('Routes:homeTitle')}
              description={i18next.t('Routes:homeDescription')}
              component={Home}
            />
            <AuthenticatedRoute
              {...ROUTES.LOGIN}
              title={i18next.t('Routes:loginTitle')}
              description={i18next.t('Routes:loginDescription')}
              component={Login}
            />
          </Switch>
          <ToastContainer position="top-right" autoClose={3000} pauseOnHover transition={Slide} />
        </Suspense>
      </div>
    </ConnectedRouter>
  );
}

export default Routes;
